// Rota falsa do painel inicial: `GET /api/v1/network/studies/overview` (espelha `StudiesOverviewEndpoints` do backend).
// Deriva dos MESMOS estados falsos das listas de estudos/dossiês/mensagens: sem dados no estado (greenfield) → tudo zerado.
import { jsonResponse } from './http';
import type { FakeSuppliersAndStudiesState } from './suppliersAndStudiesRoutes';

const STUDY_STATUSES = ['Feasibility', 'Startup', 'Enrolling', 'ActiveFollowUp', 'Closed'] as const;
const DOSSIER_STATUSES = [
  'UnderAnalysis',
  'InNegotiation',
  'LegalReview',
  'ApprovedForExecution',
  'Signed',
] as const;
const MAX_ENROLLMENT_ROWS = 8;

export function buildFakeStudiesOverview(state: FakeSuppliersAndStudiesState) {
  const unassigned = state.messages
    .filter((message) => message.classificationStatus === 'Unassigned')
    .map((message) => message.receivedAtIso)
    .sort();
  const enrollment = state.studies
    .filter((study) => study.targetEnrollment > 0)
    .sort((a, b) => b.targetEnrollment - a.targetEnrollment || a.code.localeCompare(b.code))
    .slice(0, MAX_ENROLLMENT_ROWS)
    .map((study) => ({
      code: study.code,
      title: study.title,
      status: study.status,
      targetEnrollment: study.targetEnrollment,
      currentEnrollment: study.currentEnrollment,
    }));
  const dossiersByStatus = DOSSIER_STATUSES.map((status) => ({
    status,
    count: state.dossiers.filter((dossier) => dossier.status === status).length,
  }));
  return {
    totalStudies: state.studies.length,
    studiesByStatus: STUDY_STATUSES.map((status) => ({
      status,
      count: state.studies.filter((study) => study.status === status).length,
    })),
    targetEnrollmentTotal: state.studies.reduce((sum, study) => sum + study.targetEnrollment, 0),
    currentEnrollmentTotal: state.studies.reduce((sum, study) => sum + study.currentEnrollment, 0),
    enrollment,
    totalDossiers: dossiersByStatus.reduce((sum, entry) => sum + entry.count, 0),
    dossiersByStatus,
    unassignedMailboxMessages: unassigned.length,
    oldestUnassignedReceivedAtIso: unassigned[0] ?? null,
  };
}

export function handleHomeRoute(
  request: Request,
  segments: readonly string[],
  state: FakeSuppliersAndStudiesState,
): Response | null {
  if (
    request.method.toUpperCase() === 'GET' &&
    segments.length === 3 &&
    segments[0] === 'network' &&
    segments[1] === 'studies' &&
    segments[2] === 'overview'
  ) {
    return jsonResponse(buildFakeStudiesOverview(state));
  }
  return null;
}
